Controller.$inject = [];

function Controller() {}

export function HuiDialogFooter() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            justifyContent: '@'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: () => {
            return `<div ng-transclude class="hui-dialog-footer"></div>`;
        }
    };
} 